import { render } from "./DetailImageGallery.vue?vue&type=template&id=3d6829e2&scoped=true"
import script from "./DetailImageGallery.vue?vue&type=script&lang=js"
export * from "./DetailImageGallery.vue?vue&type=script&lang=js"

import "./DetailImageGallery.vue?vue&type=style&index=0&id=3d6829e2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6829e2"]])

export default __exports__